import React, { createContext, useEffect, useState } from "react";
import axiosInstance from "../utils/axios-instance";

export const AnitaChatContext = createContext(undefined);

const AnitaChatProvider = ({ children }) => {
  const [conversations, setConversations] = useState({
    totalCount: 0,
    data: [],
  });
  const [currentConversation, setCurrentConversation] = useState(null);

  // ----------------------------------------------- FIND CONVERSATIONS --------------------------------------------

  useEffect(() => {
    const findConversations = async () => {
      try {
        const res = await axiosInstance("/voice-chat/find/conversations");
        setConversations(res.data);
      } catch (error) {
        // console.log(error);
      }
    };

    findConversations();
  }, []);

  // ------------------------------------------------ SELECT CONVERSATION -----------------------------------------
  const handleSelectConversation = (data) => {
    setCurrentConversation(data);
  };

  return (
    <AnitaChatContext.Provider
      value={{ conversations, currentConversation, handleSelectConversation }}
    >
      {children}
    </AnitaChatContext.Provider>
  );
};

export default AnitaChatProvider;
